export var BuilderConfig = {
    name: "Row",
    relativePath: "./Row.tsx",
    propDefinition: {
        name: "IFlexProps",
        path: "../Flex.tsx"
    },
    transformations: {
        flex: null
    },
    canHaveChildren: true,
    hideFromInsertMenu: true
};
